import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const AUTH_EXPIRED_MESSAGES = [
  '认证令牌已失效',
  '认证令牌已失效或已退出登录',
  '登录已过期',
  '未登录'
]

function shouldForceLogoutByMessage(message) {
  const text = String(message || '').trim()
  if (!text) return false
  return AUTH_EXPIRED_MESSAGES.some((keyword) => text.includes(keyword))
}

function redirectToLoginByScene() {
  localStorage.removeItem('token')
  localStorage.removeItem('admin_user')

  const currentUrl = window.location.href
  const encodedUrl = encodeURIComponent(currentUrl)
  const isAdminPage = window.location.pathname.startsWith('/admin')
  window.location.href = isAdminPage
    ? `/admin/login?redirect=${encodedUrl}`
    : `/login?redirect=${encodedUrl}`
}

// 请求拦截器 - 添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 处理错误和格式转换
api.interceptors.response.use(
  (response) => {
    // 自动兼容新版后端 API 格式: { status: 1|0, message: "", data: [] }
    if (response.data && typeof response.data.status !== 'undefined' && 'data' in response.data) {
      const isSuccess = response.data.status === 1;
      
      // 构造兼容旧版前端组件的数据结构 (旧版需要 success, error, 以及 data 平铺)
      const newData = {
        success: isSuccess,
        error: response.data.message || '',
        message: response.data.message || ''
      };
      
      // 为了兼容旧的解构方式 (如 res.data.token, res.data.user)，如果 data 是一个对象，则合并它
      if (response.data.data !== null && typeof response.data.data === 'object' && !Array.isArray(response.data.data)) {
        Object.assign(newData, response.data.data);
      } else {
        newData.data = response.data.data;
      }
      
      response.data = newData;

      // 如果业务状态表示失败，主动抛出异常，让前端组件的 catch 块捕获
      if (!isSuccess) {
        if (shouldForceLogoutByMessage(newData.error || newData.message)) {
          redirectToLoginByScene()
        }
        const error = new Error(newData.error || '请求失败');
        error.response = {
          data: newData,
          status: 200,
          statusText: 'OK',
          headers: response.headers,
          config: response.config
        };
        return Promise.reject(error);
      }
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      redirectToLoginByScene()
    }
    return Promise.reject(error)
  }
)

export const adminApi = {
  // 支付订单管理
  getPayments: (page = 1, limit = 20) => api.get(`/admin/payments?page=${page}&limit=${limit}`),
};

export const userApi = {
  getProfile: () => api.get('/user/profile'),
  updateProfile: (data) => api.put('/user/profile', data),
  getNotifications: (page = 1) => api.get(`/user/notifications?page=${page}`),
  markNotificationRead: (id) => api.post('/user/notifications/read', { id }),
}

export const paymentApi = {
  createOrder: (data) => api.post('/payment/create', data),
  checkStatus: (orderNo) => api.get(`/payment/status/${orderNo}`),
}

export const oceanpayApi = {
  create: (data) => api.post('/oceanpay/create', data),
}

export default api
